import { render, staticRenderFns } from "./LPDetail.vue?vue&type=template&id=f5cec50e&"
import script from "./LPDetail.vue?vue&type=script&lang=js&"
export * from "./LPDetail.vue?vue&type=script&lang=js&"
import style0 from "./LPDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports